export const sagardiConfigurations = {
  sagardi_configurations: "Sagardi Configurations",
  sagardi_integration_unsupported: `Sagardi integration is not supported yet`,
  sagardi_postprocessed_json_required: "Sagardi postprocessed json is required",
  sagardi_docCls_actCls_required:
    "Sagardi document class and account class are required",
};
